var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultsOnlyErection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9199 51.8201C12.0799 47.4401 10.0599 38.3201 14.4199 31.4601C18.7799 24.6001 27.9199 22.6001 34.7799 26.9601C41.6399 31.3201 43.6399 40.4601 39.2799 47.3201C34.8999 54.1601 25.7799 56.1801 18.9199 51.8201ZM30.4799 33.7201C27.3399 31.7201 23.1799 32.6401 21.1799 35.7801C19.1799 38.9201 20.0999 43.0802 23.2399 45.0802C26.3799 47.0802 30.5399 46.1601 32.5399 43.0201C34.5399 39.8801 33.6199 35.7201 30.4799 33.7201Z",
    fill: "#007FB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3108 10.8685L29.2457 28.197L35.9884 32.5025L47.0534 15.1739L40.3108 10.8685Z",
    fill: "#007FB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9 28.12L40.84 17.5L29.92 19.2L28.7 11.28L46.56 8.54004L51.58 25.92L43.9 28.12Z",
    fill: "#007FB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.22 53.16C12.38 48.78 10.36 39.66 14.72 32.8C19.08 25.94 28.22 23.94 35.08 28.3C41.94 32.66 43.94 41.8 39.58 48.66C35.22 55.52 26.08 57.52 19.22 53.16ZM30.78 35.06C27.64 33.06 23.48 33.98 21.48 37.12C19.48 40.26 20.4 44.42 23.54 46.42C26.68 48.42 30.84 47.5 32.84 44.36C34.84 41.22 33.92 37.06 30.78 35.06Z",
    fill: "#00A6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6216 12.1968L29.5565 29.5254L36.2991 33.8309L47.3642 16.5023L40.6216 12.1968Z",
    fill: "#00A6ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 29.4601L41.12 18.8401L30.2 20.5201L28.98 12.6201L46.86 9.86011L51.88 27.2401L44.2 29.4601Z",
    fill: "#00A6ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsOnlyErection);
export default __webpack_public_path__ + "static/media/adults_only_erection.ffdbe1a74cb932df2ac56b4323925d95.svg";
export { ForwardRef as ReactComponent };